import { ErcotRecAttributes, MretsRecAttributes } from "../types/generated/graphql";
import { TraceXSupportedRegistries } from "../types/okta.types";

export const ERCOTUnSupportedColumns = ["location", "locations"];

export const MRETSUnSupportedColumns = ["certificateType", "certificateTypes"];

export const OrderHistoryToggleColumns = [
  "type",
  "initialVolume",
  "cancelledVolume",
  "fulfilledVolume",
  "unitPrice",
  "expiryDate",
  "completedOn",
];

export type UnSupportedColumns = Record<
  TraceXSupportedRegistries,
  { unsupportedColumns: string[]; toggleColumns: string[] }
>;

export function isMretsRecAttributes(attr: MretsRecAttributes | ErcotRecAttributes): attr is MretsRecAttributes {
  return "location" in attr;
}

export function isErcotRecAttributes(attr: MretsRecAttributes | ErcotRecAttributes): attr is ErcotRecAttributes {
  return "certificateType" in attr;
}
